const HEADER_SCROLL_HIDE_THRESHOLD = 25;

function setHeaderScrollState(scrollTop, previousScrollTop) {
  const hasScrolled = scrollTop >= HEADER_SCROLL_HIDE_THRESHOLD;
  const isScrollingDown = scrollTop > previousScrollTop;

  document.body.classList.toggle(
    "scrollHeader",
    hasScrolled
  );

  document.body.classList.toggle(
    "scrollHeaderDown",
    hasScrolled && isScrollingDown
  );

  document.body.classList.toggle(
    "scrollHeaderUp",
    hasScrolled && !isScrollingDown
  );
}

let windowPreviousScrollTop = window.scrollY;
setHeaderScrollState(windowPreviousScrollTop, windowPreviousScrollTop);
window.addEventListener("scroll", function () {
  const scrollTop = window.scrollY;
  setHeaderScrollState(scrollTop, windowPreviousScrollTop);
  windowPreviousScrollTop = scrollTop;
});

export default {
  init: function () {
    const scrollSnapMain = document.querySelector(".ScrollSnap main");
    if (scrollSnapMain === null) return;
    let previousScrollTop = scrollSnapMain.scrollTop;
    setHeaderScrollState(previousScrollTop, previousScrollTop);

    scrollSnapMain.addEventListener("scroll", function () {
      const scrollTop = scrollSnapMain.scrollTop;
      setHeaderScrollState(scrollTop, previousScrollTop);
      previousScrollTop = scrollTop;
    });
  }
};
